import { withForwardedEnv } from '../config/forwardedEnv';

const FORGE_APP_ARI_PREFIX = 'ari:cloud:ecosystem::app/';

const MARKETPLACE_APP_QUERY = `query ConsentForgeAppDeveloper($cloudAppId: ID!) {
  marketplaceAppByCloudAppId(cloudAppId: $cloudAppId) {
    privacyPolicyUrl
    partner {
      name
    }
  }
}`;

export type MarketplaceDeveloperInfo = {
  vendorName?: string;
  privacyPolicy?: string;
};

type MarketplaceAppResponse = {
  data?: {
    marketplaceAppByCloudAppId?: {
      privacyPolicyUrl?: string | null;
      partner?: { name?: string | null } | null;
    } | null;
  };
};

const toForgeAppAri = (appId: string) =>
  appId.startsWith(FORGE_APP_ARI_PREFIX)
    ? appId
    : `${FORGE_APP_ARI_PREFIX}${appId}`;

export async function getMarketplaceDeveloperInfo(
  appId: string,
): Promise<MarketplaceDeveloperInfo | undefined> {
  try {
    const response = await fetch(withForwardedEnv('/gateway/api/graphql'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        operationName: 'ConsentForgeAppDeveloper',
        query: MARKETPLACE_APP_QUERY,
        variables: { cloudAppId: toForgeAppAri(appId) },
      }),
    });
    if (!response.ok) {
      return undefined;
    }
    const { data }: MarketplaceAppResponse = await response.json();
    const app = data?.marketplaceAppByCloudAppId;
    if (!app) {
      return undefined;
    }
    return {
      vendorName: app.partner?.name?.trim() || undefined,
      privacyPolicy: app.privacyPolicyUrl?.trim() || undefined,
    };
  } catch {
    return undefined;
  }
}
